import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  get_status1d77371nrw24k as get_status,
  get_cancelled2lvhzg5ousqkd as get_cancelled,
  ChangeItemReadReceipts_instance2jo5uerda8tke as ChangeItemReadReceipts_instance,
} from '../data.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  singleOrNull21olsob387p54 as singleOrNull,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
  get_session9cytjmfbg8nd as get_session,
} from '../../../../../../sdk/UserSession.mjs';
import {
  handleOne3ny7r4k654tcd as handleOne,
  isUnread3o34h317z0nzb as isUnread,
} from '../../../../../../extensions/HasReadBy.ext.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredTextWithUnread1yfsy2lami2hh as specCenteredTextWithUnread,
} from '../../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../../../../theming/sections.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../../nav/AppDimensions.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEach37zw770vd3h4l as forEach,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { unreadIconVisibley9o01zmxr3gz as unreadIconVisible } from '../../../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndMarkAsReadAction24de04tkd12ld as expandAndMarkAsReadAction,
} from '../../../../expansion.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  weightt34o7llf2uyq as weight,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../../theming/separators.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__unaryMinus_impl_x5smq036mvwk2sni6rt as MonetaryValue__unaryMinus_impl_x5smq0,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../../utils/JumpTo.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { changeRequestItemButton3gsegq8wnygxl as changeRequestItemButton } from './renderIndividualDetails.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../../../../../utils/utils.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { renderPriceChangegxsbuhvani39 as renderPriceChange } from '../../../../priceChanges.mjs';
import { ForegroundSemantic2og103ajpnjfv as ForegroundSemantic } from '../../../../../theming/colorManagement.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../../nav/crowpay.mjs';
import { ChangesRejectedDetails1h1y23it63u9u as ChangesRejectedDetails } from '../../../../../dialogs/BasicFlowForms.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderReviewedChangeOrder(_this__u8e3s4, writer, changeOrder, changeItems, cardinal) {
  // Inline function 'kotlin.with' call
  var expanded = Signal().fak(false);
  var commonStatus = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj(changeItems);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$0 = get_status(item);
      destination.v(tmp$ret$0);
    }
    return singleOrNull(toSet(destination));
  });
  var tmp = get_rawSession();
  var orderUnread = lensUnread(tmp, (it) => handleOne(it.hfv_1, ($this$handleOne, it) => $this$handleOne.baj(changeOrder)));
  var changeItemsUnread = rememberSuspending(VOID, VOID, VOID, renderReviewedChangeOrder$slambda_0(changeItems));
  var feedbackUnread = rememberSuspending(VOID, VOID, VOID, renderReviewedChangeOrder$slambda_2(changeItems));
  var itemExpandedCache = HashMap().n8();
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  var tmp_0 = get_expandButtonTheme(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? SectionSemantic_getInstance() : null);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().mg2_1);
  get_centered(view_1);
  unreadIconVisible(view_1, ($this$unreadIconVisible) => $this$unreadIconVisible.baj($this$unreadIconVisible.baj(orderUnread)) || $this$unreadIconVisible.baj($this$unreadIconVisible.baj(changeItemsUnread)) || $this$unreadIconVisible.baj($this$unreadIconVisible.baj(feedbackUnread)));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  view_1.jbb(get_centered(view_1), expandIcon(view_1, expanded));
  var tmp_1 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var c = $this$reactiveScope.baj(changeOrder);
    var tmp$ret$4 = 'Change #' + c.b58_1 + ': ' + c.s57_1;
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_1, view_2);
  view_0.fbb(p_1, view_1);
  view_0.mbg(expandAndMarkAsReadAction(view_0, expanded, remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(orderUnread).sfw($this$remember.baj(changeItemsUnread)))));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_4 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded));
  // Inline function 'com.crowpay.views.components.sectionIndentCol' call
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_Section_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_5 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  var tmp_6;
  var tmp_7 = null;
  if (!((tmp_7 == null ? null : new (Dimension())(tmp_7)) == null)) {
    tmp_6 = sizeConstraints(view_3, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_6 = Companion_getInstance();
  }
  var tmp_8 = view_3.ibb(tmp_6, indented(view_3, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.ebb(p_4, view_4);
  view_4.xbm(true);
  view_4.zb8(get_px(0));
  space(view_4, get_rem(1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_9 = KMutableProperty0();
  var tmp_10 = TextView$_get_content_$ref_4pzcwl_0(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_0(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$18 = 'Description: ' + $this$reactiveScope.baj(changeOrder).t57_1;
    this_1.set(tmp$ret$18);
    return Unit_instance;
  });
  view_4.fbb(p_5, view_5);
  space(view_4, get_rem(1));
  var tmp_11 = sizeConstraints(view_4, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(2));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.ebb(p_6, view_6);
  view_6.xbm(false);
  view_6.zb8(get_rem(1));
  if (cardinal) {
    var tmp_12 = weight(view_6, 5.0);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Space())(view_6.pc());
    var tmp0_elvis_lhs_7 = view_6.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
    view_6.ebb(p_7, view_7);
    view_6.fbb(p_7, view_7);
    view_6.jbb(tmp_12, view_7);
  } else
    view_6.jbb(weight(view_6, 5.0), bodyBold(view_6, 'Work Items'));
  var tmp_13 = view_6.ibb(weight(view_6, 1.0), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_8 = view_6.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
  view_6.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_8.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_14 = view_8.tb5_1;
  var tmp_15;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('ID') === 0) {
    tmp_15 = '\xA0';
  } else {
    tmp_15 = 'ID';
  }
  tmp_14.fbu(tmp_15);
  view_6.fbb(p_8, view_8);
  view_6.jbb(tmp_13, view_8);
  var tmp_16 = view_6.ibb(weight(view_6, 1.5), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_9 = view_6.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
  view_6.ebb(p_9, view_9);
  view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_9.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Submitted';
  var tmp_17 = view_9.tb5_1;
  var tmp_18;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_18 = '\xA0';
  } else {
    tmp_18 = value;
  }
  tmp_17.fbu(tmp_18);
  view_6.fbb(p_9, view_9);
  view_6.jbb(tmp_16, view_9);
  var tmp_19 = view_6.ibb(weight(view_6, 2.5), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_10 = view_6.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_6 : tmp0_elvis_lhs_10;
  view_6.ebb(p_10, view_10);
  view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_10.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_20 = view_10.tb5_1;
  var tmp_21;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Status') === 0) {
    tmp_21 = '\xA0';
  } else {
    tmp_21 = 'Status';
  }
  tmp_20.fbu(tmp_21);
  view_6.fbb(p_10, view_10);
  view_6.jbb(tmp_19, view_10);
  var tmp_22 = view_6.ibb(weight(view_6, 1.0), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_11 = view_6.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_6 : tmp0_elvis_lhs_11;
  view_6.ebb(p_11, view_11);
  view_11.jba(view_11.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_11.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = 'Original';
  var tmp_23 = view_11.tb5_1;
  var tmp_24;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_24 = '\xA0';
  } else {
    tmp_24 = value_0;
  }
  tmp_23.fbu(tmp_24);
  view_6.fbb(p_11, view_11);
  view_6.jbb(tmp_22, view_11);
  var tmp_25 = view_6.ibb(weight(view_6, 1.0), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_12 = view_6.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_6 : tmp0_elvis_lhs_12;
  view_6.ebb(p_12, view_12);
  view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_12.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_26 = view_12.tb5_1;
  var tmp_27;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Total') === 0) {
    tmp_27 = '\xA0';
  } else {
    tmp_27 = 'Total';
  }
  tmp_26.fbu(tmp_27);
  view_6.fbb(p_12, view_12);
  view_6.jbb(tmp_25, view_12);
  var tmp_28 = view_6.ibb(weight(view_6, 1.5), get_centered(view_6));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_13 = view_6.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_6 : tmp0_elvis_lhs_13;
  view_6.ebb(p_13, view_13);
  view_13.jba(view_13.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view_13.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_29 = view_13.tb5_1;
  var tmp_30;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Date') === 0) {
    tmp_30 = '\xA0';
  } else {
    tmp_30 = 'Date';
  }
  tmp_29.fbu(tmp_30);
  view_6.fbb(p_13, view_13);
  view_6.jbb(tmp_28, view_13);
  view_4.fbb(p_6, view_6);
  view_4.jbb(tmp_11, view_6);
  greySeparator(view_4);
  if (cardinal) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_14 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_14 = view_4.cbb_1;
    var p_14 = tmp0_elvis_lhs_14 == null ? view_4 : tmp0_elvis_lhs_14;
    view_4.ebb(p_14, view_14);
    view_14.xbm(true);
    view_14.zb8(get_px(0));
    var tmp_31 = sizeConstraints(view_14, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3));
    var tmp_32 = renderReviewedChangeOrder$lambda;
    var tmp_33 = ($this$tableRow) => $this$tableRow.baj(changeOrder).b58_1;
    var tmp_34 = ($this$tableRow) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$tableRow.baj(changeItems);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.u94();
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$74 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$74);
      }
      var tmp$ret$75 = sum;
      return new (MonetaryValue())(tmp$ret$75);
    };
    var tmp_35 = ($this$tableRow) => $this$tableRow.baj(commonStatus);
    var tmp_36 = ($this$tableRow) => {
      var tmp = $this$tableRow.baj(commonStatus) == null ? null : Companion_instance.p91(0n);
      return tmp == null ? null : new (MonetaryValue())(tmp);
    };
    var tmp_37 = ($this$tableRow) => {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$tableRow.baj(changeItems);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp0_elvis_lhs = item.x94();
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? item.y94() : tmp0_elvis_lhs;
        var tmp$ret$76 = tmp1_elvis_lhs == null ? item.h95() : tmp1_elvis_lhs;
        destination.v(tmp$ret$76);
      }
      return singleOrNull(toSet(destination));
    };
    view_14.jbb(tmp_31, renderReviewedChangeOrder$_anonymous_$_anonymous_$_anonymous_$tableRow_nvatp8(view_14, VOID, VOID, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, renderReviewedChangeOrder$lambda_0));
    view_4.fbb(p_14, view_14);
  }
  greySeparator(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_15 = view_4.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_4 : tmp0_elvis_lhs_15;
  view_4.ebb(p_15, view_15);
  view_15.xbm(true);
  view_15.zb8(get_px(0));
  forEach(view_15, changeItems, ($this$forEach, changeItem) => {
    changeRequestItemButton($this$forEach, changeItem, VOID, itemExpandedCache, ($this$changeRequestItemButton, itemExpanded) => {
      var tmp = JumpTo_getInstance().ng3_1;
      var tmp_0 = changeItem.h40();
      tmp.xg4(tmp_0, $this$changeRequestItemButton, VOID, () => {
        expanded.mam(true);
        var tmp;
        if (!get_cancelled(changeItem)) {
          itemExpanded.mam(true);
          tmp = Unit_instance;
        }
        return Unit_instance;
      });
      var tmp_1 = !get_cancelled(changeItem);
      var tmp_2 = ($this$tableRow) => new (Pair())(changeItem.ngp_1, changeItem.z94());
      var tmp_3 = ($this$tableRow) => changeItem.w94();
      var tmp_4 = ($this$tableRow) => {
        var tmp = get_cancelled(changeItem) ? MonetaryValue__unaryMinus_impl_x5smq0(changeItem.ogp_1) : changeItem.u94();
        return tmp == null ? null : new (MonetaryValue())(tmp);
      };
      var tmp_5 = ($this$tableRow) => cardinal && !($this$tableRow.baj(commonStatus) == null) ? null : get_status(changeItem);
      var tmp_6 = ($this$tableRow) => {
        var tmp = cardinal && !($this$tableRow.baj(commonStatus) == null) ? null : changeItem.ogp_1;
        return tmp == null ? null : new (MonetaryValue())(tmp);
      };
      var tmp_7 = ($this$tableRow) => {
        // Inline function 'kotlin.let' call
        var it = changeItem;
        var tmp0_elvis_lhs = it.x94();
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? it.y94() : tmp0_elvis_lhs;
        return tmp1_elvis_lhs == null ? it.h95() : tmp1_elvis_lhs;
      };
      renderReviewedChangeOrder$_anonymous_$_anonymous_$_anonymous_$tableRow_nvatp8($this$changeRequestItemButton, itemExpanded, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, ($this$tableRow) => isUnread(changeItem.t91(), $this$tableRow.baj(get_session()).efv_1));
      return Unit_instance;
    });
    return Unit_instance;
  });
  view_4.fbb(p_15, view_15);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (Space())(view_4.pc());
  var tmp0_elvis_lhs_16 = view_4.cbb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_4 : tmp0_elvis_lhs_16;
  view_4.ebb(p_16, view_16);
  shownDefaultFalse(view_16, ($this$shownDefaultFalse) => {
    var tmp0 = $this$shownDefaultFalse.baj(changeItems);
    var tmp$ret$89;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$89 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!(element.y94() == null)) {
          tmp$ret$89 = true;
          break $l$block_0;
        }
      }
      tmp$ret$89 = false;
    }
    return tmp$ret$89;
  });
  view_4.fbb(p_16, view_16);
  var tmp_38 = view_4.ibb(get_atEnd(view_4), get_secondaryButton(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (Button())(view_4.pc());
  var tmp0_elvis_lhs_17 = view_4.cbb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_4 : tmp0_elvis_lhs_17;
  view_4.ebb(p_17, view_17);
  shownDefaultFalse(view_17, ($this$shownDefaultFalse) => {
    var tmp0 = $this$shownDefaultFalse.baj(changeItems);
    var tmp$ret$94;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$94 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!(element.y94() == null)) {
          tmp$ret$94 = true;
          break $l$block_2;
        }
      }
      tmp$ret$94 = false;
    }
    return tmp$ret$94;
  });
  specCenteredTextWithUnread(view_17, 'View Reason', ($this$specCenteredTextWithUnread) => $this$specCenteredTextWithUnread.baj($this$specCenteredTextWithUnread.baj(feedbackUnread)));
  onClick(view_17, VOID, VOID, renderReviewedChangeOrder$slambda_4(changeOrder, changeItems, _this__u8e3s4));
  view_4.fbb(p_17, view_17);
  view_4.jbb(tmp_38, view_17);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (Space())(view_4.pc());
  var tmp0_elvis_lhs_18 = view_4.cbb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_4 : tmp0_elvis_lhs_18;
  view_4.ebb(p_18, view_18);
  view_4.fbb(p_18, view_18);
  view_3.fbb(p_4, view_4);
  view_3.jbb(tmp_8, view_4);
  view.fbb(p_3, view_3);
  var tmp$ret$111 = view.jbb(tmp_5, view_3);
  view.jbb(tmp_4, tmp$ret$111);
  greySeparator(view, ($this$greySeparator) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
    reactiveScope($this$greySeparator, ($this$reactiveScope) => {
      var tmp$ret$112 = !$this$reactiveScope.baj(expanded);
      this_0.set(tmp$ret$112);
      return Unit_instance;
    });
    return Unit_instance;
  });
  writer.fbb(p, view);
  return view;
}
function renderReviewedChangeOrder$_anonymous_$_anonymous_$_anonymous_$tableRow_nvatp8(_this__u8e3s4, expanded, allowExpand, label, id, submitted, status, original, date, isUnread) {
  expanded = expanded === VOID ? null : expanded;
  allowExpand = allowExpand === VOID ? true : allowExpand;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_rem(1));
  if (expanded == null)
    view.jbb(view.ibb(weight(view, 5.0), get_centered(view)), bodyBold(view, 'Group Summary'));
  else {
    var tmp = weight(view, 5.0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().mg2_1);
    get_centered(view_0);
    unreadIconVisible(view_0, ($this$unreadIconVisible) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return isUnread($this$unreadIconVisible);
    });
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance();
    if (allowExpand) {
      view_0.jbb(get_centered(view_0), expandIcon(view_0, expanded));
    }
    var tmp_0 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_1(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_1(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp0_safe_receiver = label($this$reactiveScope);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.af_1;
      var tmp$ret$3 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      this_0.set(tmp$ret$3);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_0, view_1);
    var tmp_3 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl_2(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_2(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp0_safe_receiver = label($this$reactiveScope);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bf_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f95_1;
      var tmp$ret$11 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      this_1.set(tmp$ret$11);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_3, view_2);
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
  }
  var tmp_6 = view.ibb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  view_3.bbs(Align_Center_getInstance());
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_3(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_3(view_3));
  var actionToCalculate = id;
  reactiveScope(view_3, ($this$reactiveScope) => {
    this_2.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  view.fbb(p_3, view_3);
  view.jbb(tmp_6, view_3);
  var tmp_9 = weight(view, 1.5);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_4 = view.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.ebb(p_4, view_4);
  view_4.jbb(get_centered(view_4), renderPriceChange(view_4, true, submitted));
  view.fbb(p_4, view_4);
  view.jbb(tmp_9, view_4);
  var tmp_10 = view.ibb(weight(view, 2.5), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_5 = view.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance()));
  dynamicTheme(view_5, ($this$dynamicTheme) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_safe_receiver = status($this$dynamicTheme);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = ForegroundSemantic().agi(tmp0_safe_receiver.vh7_1);
    }
    return tmp;
  });
  view_5.bbs(Align_Center_getInstance());
  var tmp_11 = KMutableProperty0();
  var tmp_12 = TextView$_get_content_$ref_4pzcwl_4(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_4(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_safe_receiver = status($this$reactiveScope);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uh7_1;
    var tmp$ret$35 = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
    this_3.set(tmp$ret$35);
    return Unit_instance;
  });
  view.fbb(p_5, view_5);
  view.jbb(tmp_10, view_5);
  var tmp_13 = view.ibb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
  view_6.bbs(Align_Center_getInstance());
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_5(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_5(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = original($this$reactiveScope);
    var tmp0_safe_receiver = tmp == null ? null : tmp.a5s_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = MonetaryValue__toString_impl_xslc77(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp$ret$43 = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
    this_4.set(tmp$ret$43);
    return Unit_instance;
  });
  view.fbb(p_6, view_6);
  view.jbb(tmp_13, view_6);
  var tmp_16 = view.ibb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_7 = view.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
  view_7.bbs(Align_Center_getInstance());
  var tmp_17 = KMutableProperty0();
  var tmp_18 = TextView$_get_content_$ref_4pzcwl_6(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb_6(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = original($this$reactiveScope);
    var o = tmp == null ? null : tmp.a5s_1;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp_0 = submitted($this$reactiveScope);
    var s = tmp_0 == null ? null : tmp_0.a5s_1;
    var tmp_1;
    var tmp_2;
    var tmp_3 = o;
    if (!((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null)) {
      var tmp_4 = s;
      tmp_2 = !((tmp_4 == null ? null : new (MonetaryValue())(tmp_4)) == null);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = MonetaryValue__toString_impl_xslc77(MonetaryValue__plus_impl_c1ylt(o, s));
    } else {
      tmp_1 = '-';
    }
    var tmp$ret$52 = tmp_1;
    this_5.set(tmp$ret$52);
    return Unit_instance;
  });
  view.fbb(p_7, view_7);
  view.jbb(tmp_16, view_7);
  var tmp_19 = view.ibb(weight(view, 1.5), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_8 = view.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
  view.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
  view_8.bbs(Align_Center_getInstance());
  var tmp_20 = KMutableProperty0();
  var tmp_21 = TextView$_get_content_$ref_4pzcwl_7(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_6 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb_7(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_safe_receiver = date($this$reactiveScope);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : format(tmp0_safe_receiver, Formats_getInstance().j8z_1);
    var tmp$ret$60 = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
    this_6.set(tmp$ret$60);
    return Unit_instance;
  });
  view.fbb(p_8, view_8);
  view.jbb(tmp_19, view_8);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  var tmp = ChangeItemReadReceipts_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ehc_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = tmp.uh8(tmp$ret$0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
var renderReviewedChangeOrder$slambdaClass;
function renderReviewedChangeOrder$slambda() {
  if (renderReviewedChangeOrder$slambdaClass === VOID) {
    class $ {
      constructor($changeItems) {
        this.ehc_1 = $changeItems;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderReviewedChangeOrder$slambdaClass = $;
  }
  return renderReviewedChangeOrder$slambdaClass;
}
function renderReviewedChangeOrder$slambda_0($changeItems) {
  var i = new (renderReviewedChangeOrder$slambda())($changeItems);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$rememberSuspending, $completion) {
  var tmp = ChangeItemReadReceipts_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fhc_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = tmp.vh8(tmp$ret$0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
var renderReviewedChangeOrder$slambdaClass_0;
function renderReviewedChangeOrder$slambda_1() {
  if (renderReviewedChangeOrder$slambdaClass_0 === VOID) {
    class $ {
      constructor($changeItems) {
        this.fhc_1 = $changeItems;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderReviewedChangeOrder$slambdaClass_0 = $;
  }
  return renderReviewedChangeOrder$slambdaClass_0;
}
function renderReviewedChangeOrder$slambda_2($changeItems) {
  var i = new (renderReviewedChangeOrder$slambda_1())($changeItems);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderReviewedChangeOrder$lambda($this$tableRow) {
  return null;
}
function renderReviewedChangeOrder$lambda_0($this$tableRow) {
  return false;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ghc_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.hhc_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.ihc_1.wgk();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4.f5c_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.ihc_1.fgl();
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.xgd(new (ChangesRejectedDetails())(tmp_1, tmp_3, tmp_5, tmp$ret$3.x5i_1));
  return Unit_instance;
}
var renderReviewedChangeOrder$slambdaClass_1;
function renderReviewedChangeOrder$slambda_3() {
  if (renderReviewedChangeOrder$slambdaClass_1 === VOID) {
    class $ {
      constructor($changeOrder, $changeItems, $this_renderReviewedChangeOrder) {
        this.ghc_1 = $changeOrder;
        this.hhc_1 = $changeItems;
        this.ihc_1 = $this_renderReviewedChangeOrder;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderReviewedChangeOrder$slambdaClass_1 = $;
  }
  return renderReviewedChangeOrder$slambdaClass_1;
}
function renderReviewedChangeOrder$slambda_4($changeOrder, $changeItems, $this_renderReviewedChangeOrder) {
  var i = new (renderReviewedChangeOrder$slambda_3())($changeOrder, $changeItems, $this_renderReviewedChangeOrder);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.wb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  renderReviewedChangeOrder as renderReviewedChangeOrderqup1a1u5klok,
};
//endregion

//# sourceMappingURL=reviewedChangeOrder.mjs.map
